import type { ReportStrategyAccountRef, ReportStrategyResponse } from "../../../types/reports";
import {
  getReportStrategyDetail,
  updateReportStrategy,
} from "../../../services/reportsApi";
import {
  brokerAccountRefKey,
  resolveEntityBrokerAccounts,
  type BrokerAccountRef,
} from "../../../utils/brokerAccountRef";

function toAccountPayload(ref: BrokerAccountRef): ReportStrategyAccountRef {
  return {
    brokerName: ref.brokerName,
    brokerAccountCode: ref.brokerAccountCode,
  };
}

/** Merge `account` into the strategy's membership if it is not already linked. */
export async function ensureStrategyLinkedToAccount(
  strategyId: string,
  account: BrokerAccountRef
): Promise<ReportStrategyResponse> {
  const id = strategyId.trim();
  const brokerName = account.brokerName.trim().toLowerCase();
  const brokerAccountCode = account.brokerAccountCode.trim();
  if (!id || !brokerName || !brokerAccountCode) {
    throw new Error("Strategy and account are required.");
  }

  const detail = await getReportStrategyDetail(id);
  const existing = resolveEntityBrokerAccounts({
    accounts: detail.accounts,
    brokerName: detail.broker_name,
    brokerAccountCode: detail.broker_account_code,
  });
  const nextKey = brokerAccountRefKey({ brokerName, brokerAccountCode });
  if (existing.some((ref) => brokerAccountRefKey(ref) === nextKey)) {
    return detail;
  }

  const accounts = [...existing, { brokerName, brokerAccountCode }].map(toAccountPayload);
  const primary = accounts[0]!;
  return updateReportStrategy(id, {
    accounts,
    broker_name: primary.brokerName,
    broker_account_code: primary.brokerAccountCode,
  });
}
